/**
 * White-Label Tenant Types
 * These extend the auto-generated Supabase types for tenant management
 */

export interface Tenant {
  id: string;
  name: string;
  slug: string;
  domain: string | null;
  subdomain: string | null;
  settings: TenantMetaSettings;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface TenantMetaSettings {
  is_master?: boolean;
  features?: Record<string, boolean | string | number | null>;
  [key: string]: unknown;
}

export interface TenantSettings {
  id: string;
  tenant_id: string;
  // Branding
  logo_url: string | null;
  logo_dark_url: string | null;
  favicon_url: string | null;
  // Colors
  primary_color: string;
  secondary_color: string;
  accent_color: string;
  background_color: string;
  text_color: string;
  // Styling
  custom_css: string | null;
  font_family: string;
  // Email
  email_from_name: string | null;
  email_from_address: string | null;
  email_reply_to: string | null;
  email_logo_url: string | null;
  // Footer/Legal
  powered_by_visible: boolean;
  powered_by_text: string | null;
  powered_by_url: string | null;
  terms_url: string | null;
  privacy_url: string | null;
  support_email: string | null;
  support_url: string | null;
  // Login customization
  login_title: string | null;
  login_subtitle: string | null;
  login_background_url: string | null;
  // Feature flags
  features: Record<string, boolean | string | number | null>;
  // Metadata
  created_at: string;
  updated_at: string;
}

export interface TenantAdmin {
  id: string;
  tenant_id: string;
  user_id: string;
  role: 'admin' | 'owner' | 'viewer';
  created_at: string;
}

// Combined tenant with settings for context
export interface TenantWithSettings extends Omit<Tenant, 'settings'> {
  settings: TenantSettings;
}

// Insert types
export type TenantInsert = Omit<Tenant, 'id' | 'created_at' | 'updated_at'>;
export type TenantSettingsInsert = Omit<TenantSettings, 'id' | 'created_at' | 'updated_at'>;

// Update types
export type TenantUpdate = Partial<TenantInsert>;
export type TenantSettingsUpdate = Partial<Omit<TenantSettingsInsert, 'tenant_id'>>;

// Default values
export const DEFAULT_TENANT_SETTINGS: Omit<TenantSettings, 'id' | 'tenant_id' | 'created_at' | 'updated_at'> = {
  logo_url: null,
  logo_dark_url: null,
  favicon_url: null,
  primary_color: '#233C6F',
  secondary_color: '#EF5E33',
  accent_color: '#10B981',
  background_color: '#FFFFFF',
  text_color: '#1F2937',
  custom_css: null,
  font_family: 'Inter',
  email_from_name: null,
  email_from_address: null,
  email_reply_to: null,
  email_logo_url: null,
  powered_by_visible: true,
  powered_by_text: 'Powered by MEDD-SIM',
  powered_by_url: 'https://medd.com.au',
  terms_url: null,
  privacy_url: null,
  support_email: null,
  support_url: null,
  login_title: null,
  login_subtitle: null,
  login_background_url: null,
  features: {},
};

// Master tenant ID constant
export const MASTER_TENANT_ID = '00000000-0000-0000-0000-000000000001';
